const faqItems = [
  {
    id: 1,
    question: '91樱花需要注册会员才能观看吗？',
    answer: '不需要。91樱花全站内容免费观看，无需注册会员即可在线观看和下载所有动漫资源。我们坚持免费运营理念，让每一位动漫爱好者都能无门槛享受追番乐趣。',
  },
  {
    id: 2,
    question: '91樱花的动漫资源画质如何？',
    answer: '平台全站提供1080P超清画质，部分热门番剧支持4K画质选项。我们采用多线路CDN加速技术，确保播放流畅不卡顿。下载同样支持高清画质，你可以根据需求选择合适的清晰度。',
  },
  {
    id: 3,
    question: '日漫和国漫的资源都齐全吗？',
    answer: '是的。91樱花已收录超过20000部动漫作品，涵盖日漫、国漫、剧场版、OVA等全品类。无论是当季新番还是经典老番，你基本都能找到。我们的资源库每日更新，第一时间同步最新番剧。',
  },
  {
    id: 4,
    question: '支持哪些设备观看？需要下载APP吗？',
    answer: '91樱花支持手机、平板、电脑等多端访问，无需下载APP。直接通过浏览器访问即可畅享高清动漫。我们针对移动端做了专门优化，在小屏幕上也能获得流畅的追番体验。',
  },
  {
    id: 5,
    question: '动漫资源是无删减版吗？',
    answer: '是的。91樱花所有番剧均为完整版，无删减无和谐，保留原汁原味的剧情内容。我们致力于为动漫迷提供最纯粹的观看体验，不修改不裁剪任何画面和情节。',
  },
  {
    id: 6,
    question: '如何下载动漫到本地观看？',
    answer: '在视频播放页面可以找到下载选项，支持多种清晰度选择和批量下载功能。我们提供多条下载线路，速度稳定且支持断点续传，让你随时随地离线追番。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            关于91樱花动漫平台的常见疑问，快速解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto grid grid-cols-1 gap-3 md:gap-4">
          {faqItems.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6"
            >
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-accent-500 shrink-0 mt-0.5">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-question-answer-line text-sm"></i>
                  </div>
                </span>
                {faq.question}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-7">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}